import { all, fork } from 'redux-saga/effects';

import get from './get';

export default function* customer() {
  yield all([fork(get)]);
}
